import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import { Cards } from 'src/components';
import { formatArea, formatCondition } from 'src/utils/formatters';


const useStyles = makeStyles(theme => ({
  goodPerformance: {
    color: theme.palette.success.main,
    fontWeight: 600,
  },
  badPerformance: {
    color: theme.palette.error.main,
    fontWeight: 600,
  },
  neutralPerformance: {
    color: theme.palette.text.secondary,
    fontWeight: 600,
  },
  subtitle: {
    fontWeight: 500,
    textTransform: 'uppercase',
    color: theme.palette.common.gray600,
    lineHeight: 1,
  },
}));

const SitesSummaryTable = ({ sites = [] }) => {
  const classes = useStyles();

  const getPerformance = (siteCondition, comparisonCondition) => {
    if ((!siteCondition && siteCondition !== 0) || (!comparisonCondition && comparisonCondition !== 0)) {
      return { label: 'N/D', isGood: null };
    }

    const isGood = parseFloat(siteCondition) >= parseFloat(comparisonCondition);
    return { label: isGood ? 'Ganancia' : 'Pérdida', isGood };
  };

  const columns = [
    {
      title: 'Sitio',
      field: 'name',
    },
    {
      title: 'Superficie [ha]',
      field: 'surface',
      render: site => formatArea(site.surface),
    },
    {
      title: 'Proporción de vegetación natural (%) (2024)',
      field: 'naturalVegetationProportion',
      render: site => site.naturalVegetationProportion ? `${site.naturalVegetationProportion}%` : 'N/D',
    },
    {
      title: 'Proporción de vegetación natural de referencia (2020)',
      field: 'referenceNaturalVegetation',
      render: site => site.referenceNaturalVegetation ? `${site.referenceNaturalVegetation}%` : 'N/D',
    },
    {
      title: 'Condición (2024)',
      field: 'condition',
      render: site => formatCondition(site.condition),
    },
    {
      title: 'Condición de referencia (2020)',
      field: 'comparisonCondition',
      render: site => formatCondition(site.comparisonCondition),
    },
    {
      title: 'Desempeño',
      field: 'performance',
      width: '80px',
      render: site => {
        const performance = getPerformance(site.condition, site.comparisonCondition);

        let className = classes.neutralPerformance;
        if (performance.isGood === true) {
          className = classes.goodPerformance;
        } else if (performance.isGood === false) {
          className = classes.badPerformance;
        }

        return (
          <span className={className}>
            {performance.label}
          </span>
        );
      },
    },
  ];

  const sitesToShow = sites || [];

  return (
    <Cards
      values={sitesToShow}
      variant="condensed"
      columns={columns}
      showPagination={sitesToShow.length > 5}
    />

  );
};

SitesSummaryTable.propTypes = {
  sites: PropTypes.array,
};


export {
  SitesSummaryTable,
};